import React, { Component } from "react";

import {
    MDBBtn,
    MDBModalBody,
    MDBModalHeader,
    MDBRow,
    MDBCol,
    MDBInput,
    MDBTooltip,
    MDBIcon,
} from "mdbreact";

import "react-phone-number-input/style.css";
import SelectSearch, { fuzzySearch } from "react-select-search";

import { withTranslation } from "react-i18next";

class AddKeypool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: null,
            content: null,
            venueName: this.props.venueName,
            phoneNumber: undefined,
            phone: undefined,
            email: undefined,
            loading_prop_groups: false,
            invalidPhone: null,
            invalidCountry: null,
            invalidState: null,
            displayOrder: undefined,
            setKeypoolRole: this.props.localOnly ? 'local' : undefined,
            action: "create", // "create" or "assign"
            selectedExistingKeypool: undefined,
            keypoolSearchText: "",
            venueSelectedForKeypool: false,
            selectedUnit: undefined,
        };
    }

    componentDidMount() {
        // If a venue is already selected when component mounts, mark it as selected
        if ((this.state.setKeypoolRole === "local" || this.state.setKeypoolRole === "unit") && 
            this.props.globalKey === true && 
            this.props.venueID && 
            this.props.venueID !== "") {
            this.setState({ venueSelectedForKeypool: true });
        }
    }

    componentDidUpdate(prevProps) {
        // Track when venue is actually selected via attributeForm
        if ((this.state.setKeypoolRole === "local" || this.state.setKeypoolRole === "unit") && 
            this.props.globalKey === true && 
            prevProps.venueID !== this.props.venueID && 
            this.props.venueID && 
            this.props.venueID !== "") {
            this.setState({ venueSelectedForKeypool: true });
        }
    }

    componentDidMount() {
        // If a venue is already selected when component mounts, mark it as selected
        if ((this.state.setKeypoolRole === "local" || this.state.setKeypoolRole === "unit") && 
            this.props.globalKey === true && 
            this.props.venueID && 
            this.props.venueID !== "") {
            this.setState({ venueSelectedForKeypool: true });
        }
    }

    componentDidUpdate(prevProps) {
        // Track when venue is actually selected via attributeForm
        if ((this.state.setKeypoolRole === "local" || this.state.setKeypoolRole === "unit") && 
            this.props.globalKey === true && 
            prevProps.venueID !== this.props.venueID && 
            this.props.venueID && 
            this.props.venueID !== "") {
            this.setState({ venueSelectedForKeypool: true });
        }
    }

    submitAddKeypool = (event) => {
        event.preventDefault();

        if (this.state.action === "create" && this.state.ssid !== undefined) {
            this.props.submitAddKeypool(
                this.state.ssid,
                this.props.venueID,
                this.state.setKeypoolRole,
                this.state.displayOrder,
                this.state.setKeypoolRole,
                this.state.selectedUnit,
                this.state.currentUnitSSIDs
            );
        } else if (this.state.action === "assign" && this.state.selectedExistingKeypool !== undefined) {
            const ssid = this.props.allKeypools[this.state.selectedExistingKeypool]["ssid"];
            this.props.submitAssignKeypool(
                this.state.selectedExistingKeypool,
                this.props.venueID,
                ssid
            );
        }
    };

    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    changeHandlerRadio = (nr) => () => {
        this.setState({
            setKeypoolRole: nr,
            venueSelectedForKeypool: (nr === "local" || nr === "unit") && this.props.globalKey === true && this.props.venueID && this.props.venueID !== "" ? true : false,
            selectedUnit: undefined,
        });
    };

    changeHandlerAction = (action) => () => {
        this.setState({
            action: action,
            // Reset fields when switching
            ssid: undefined,
            selectedExistingKeypool: undefined,
            setKeypoolRole: action === "create" && this.props.localOnly ? 'local' : action === "create" ? undefined : undefined,
            venueSelectedForKeypool: false,
            selectedUnit: undefined,
        });
    };

    handleSelectExistingKeypool = (value) => {
        this.setState({
            selectedExistingKeypool: value,
        });
    };

    handleSelectUnit = (value) => {
        // Look up current SSIDs for the selected unit from keyPoolList by matching Scope to UnitID_internal
        let currentUnitSSIDs = [];
        
        if (this.props.keyPoolList) {
            Object.keys(this.props.keyPoolList).forEach(key => {
                const keypool = this.props.keyPoolList[key];
                if (keypool["Scope"] === value) {
                    currentUnitSSIDs.push(keypool["ssid"]);
                }
            });
        }

        // Fallback: also check Units-Building-Floor-List-Subscribers
        if (currentUnitSSIDs.length === 0) {
            const unitsBuildingFloorData = this.props["Units-Building-Floor-List-Subscribers"];
            if (unitsBuildingFloorData) {
                Object.keys(unitsBuildingFloorData).forEach(unitKey => {
                    Object.keys(unitsBuildingFloorData[unitKey]).forEach(buildingKey => {
                        Object.keys(unitsBuildingFloorData[unitKey][buildingKey]).forEach(floorKey => {
                            const floorData = unitsBuildingFloorData[unitKey][buildingKey][floorKey];
                            if (floorData.UnitID_internal === value && floorData.NetworkConfiguration && floorData.NetworkConfiguration.VenueUnitSSID) {
                                currentUnitSSIDs = [...floorData.NetworkConfiguration.VenueUnitSSID];
                            }
                        });
                    });
                });
            }
        }

        this.setState({
            selectedUnit: value,
            currentUnitSSIDs: currentUnitSSIDs,
        });
    };

    getFilteredKeypools = () => {
        if (!this.props.allKeypools) return [];
        
        const keypools = Object.keys(this.props.allKeypools).map(key => {
            const ssid = this.props.allKeypools[key]["ssid"];
            const authMechanism = this.props.allKeypools[key]["AuthenticationMechanism"];
            const scope = this.props.allKeypools[key]["Scope"] || "local";
            
            let displayName = ssid;
            if (authMechanism) {
                displayName += ` - ${authMechanism}`;
            }
            displayName += ` - ${scope}`;
            
            return {
                value: key,
                name: displayName,
                scope: scope,
            };
        });

        return keypools;
    };

    getUnitOptions = () => {
        const unitsBuildingFloorData = this.props["Units-Building-Floor-List-Subscribers"];
        
        console.log("Units-Building-Floor-List-Subscribers prop:", unitsBuildingFloorData);
        console.log("All props:", this.props);
        
        if (!unitsBuildingFloorData) {
            console.log("No unitsBuildingFloorData found");
            return [];
        }
        
        const options = [];
        
        // Iterate through units (top level keys like "Venuemenu001")
        Object.keys(unitsBuildingFloorData).forEach(unitKey => {
            const unitObj = unitsBuildingFloorData[unitKey];
            console.log("Processing unit:", unitKey, unitObj);
            
            // Iterate through buildings (second level keys like "Courage")
            Object.keys(unitObj).forEach(buildingKey => {
                const buildingObj = unitObj[buildingKey];
                console.log("Processing building:", buildingKey, buildingObj);
                
                // Iterate through floors (third level keys like "101")
                Object.keys(buildingObj).forEach(floorKey => {
                    const floorData = buildingObj[floorKey];
                    console.log("Processing floor:", floorKey, floorData);
                    
                    // Create display name as Unit/Building/Floor
                    const displayName = `${unitKey}/${buildingKey}/${floorKey}`;
                    
                    // Use UnitID_internal as the value if available, otherwise construct from keys
                    const unitIDInternal = floorData.UnitID_internal || `${unitKey}|${buildingKey}|${floorKey}`;
                    
                    options.push({
                        name: displayName,
                        value: unitIDInternal,
                    });
                });
            });
        });
        
        console.log("Generated unit options:", options);
        return options;
    };

    render() {
        const { t } = this.props;
        const filteredKeypools = this.getFilteredKeypools();
        const unitOptions = this.getUnitOptions();
        // A maximum of 4 Unit Level SSIDs are allowed per unit (NETWORKUI-722)
        const MAX_UNIT_SSIDS = 4;
        const currentUnitSSIDCount = this.state.currentUnitSSIDs ? this.state.currentUnitSSIDs.length : 0;
        const atUnitSSIDLimit =
            this.state.setKeypoolRole === "unit" &&
            currentUnitSSIDCount >= MAX_UNIT_SSIDS &&
            !(this.state.currentUnitSSIDs || []).includes(this.state.ssid);

        return (
            <>
                <MDBModalHeader toggle={this.props.toggleAddKeypool}>
                    <h4>Add Keypool</h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitAddKeypool}
                        noValidate
                    >
                        {/* Action Selection - Hidden when globalKey is true (from OperatorInfo) */}
                        {!this.props.globalKey && (
                            <>
                                <MDBRow className="mb-3">
                                    <MDBCol sm="12">
                                        <p className="mb-2"><strong>Select Action:</strong></p>
                                        <div className="form-check-inline">
                                            <MDBInput
                                                label="Create New Keypool"
                                                type="radio"
                                                id="actionCreate"
                                                name="action"
                                                onClick={this.changeHandlerAction("create")}
                                                checked={this.state.action === "create"}
                                            />
                                        </div>
                                        <div className="form-check-inline">
                                            <MDBInput
                                                label="Assign Existing Keypool"
                                                type="radio"
                                                id="actionAssign"
                                                name="action"
                                                onClick={this.changeHandlerAction("assign")}
                                                checked={this.state.action === "assign"}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <hr />
                            </>
                        )}

                        {this.state.action === "create" ? (
                            /* CREATE NEW KEYPOOL FORM */
                            <>
                                {this.props.globalKey !== true ? (
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="12">
                                            <label
                                                htmlFor="defaultFormLoginEmailEx"
                                                className="black-text"
                                            >
                                                Venue Name*
                                            </label>
                                            <input
                                                disabled
                                                name="venueName"
                                                id="venueName"
                                                className="form-control emailInput"
                                                onChange={this.changeHandler}
                                                value={this.props.venueName}
                                            />
                                            <div className="invalid-feedback">
                                                Please provide a valid name
                                            </div>
                                        </MDBCol>
                                        <MDBCol col="6"></MDBCol>
                                    </MDBRow>
                                ) : (
                                    ""
                                )}
                                <MDBRow>
                                    <MDBCol sm="12" lg="12">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text"
                                        >
                                            SSID
                                        </label>
                                        <input
                                            required
                                            name="ssid"
                                            id="ssid"
                                            className="form-control"
                                            onChange={this.changeHandler}
                                            value={this.state.ssid}
                                        />
                                        <div className="invalid-feedback">
                                            Please provide a valid SSID name.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <br />
                                    <>
                                        <p className="mb-0">Keypool Type:</p>
                                        <MDBInput
                                            label="Global"
                                            type="radio"
                                            id="setKeypoolRoleGlobal"
                                            name="Global"
                                            onClick={this.changeHandlerRadio("global")}
                                            checked={
                                                this.state.setKeypoolRole === "global"
                                                    ? true
                                                    : false
                                            }
                                        >
                                            <MDBTooltip
                                                material
                                                placement="left"
                                                className="rightTooltip"
                                                style={{ display: "block" }}
                                            >
                                                <MDBIcon far icon="question-circle" />
                                                <span>
                                                    This keypool will be available at all venues
                                                </span>
                                            </MDBTooltip>
                                        </MDBInput>
                                        <MDBInput
                                            label="Venue"
                                            type="radio"
                                            id="setKeypoolRoleLocal"
                                            name="Venue"
                                            onClick={this.changeHandlerRadio("local")}
                                            checked={
                                                this.state.setKeypoolRole === "local"
                                                    ? true
                                                    : false
                                            }
                                        >
                                            <MDBTooltip
                                                material
                                                placement="left"
                                                className="rightTooltip"
                                                style={{ display: "block" }}
                                            >
                                                <MDBIcon far icon="question-circle" />
                                                <span>
                                                    This keypool will only be available at the
                                                    selected venue
                                                </span>
                                            </MDBTooltip>
                                        </MDBInput>
                                        <MDBInput
                                            label="Unit"
                                            type="radio"
                                            id="setKeypoolRoleUnit"
                                            name="Unit"
                                            onClick={this.changeHandlerRadio("unit")}
                                            checked={
                                                this.state.setKeypoolRole === "unit"
                                                    ? true
                                                    : false
                                            }
                                        >
                                            <MDBTooltip
                                                material
                                                placement="left"
                                                className="rightTooltip"
                                                style={{ display: "block" }}
                                            >
                                                <MDBIcon far icon="question-circle" />
                                                <span>
                                                    This keypool will only be available at the
                                                    selected unit
                                                </span>
                                            </MDBTooltip>
                                        </MDBInput>
                                        <br />
                                    </>
                                
                                {(this.state.setKeypoolRole === "local" || this.state.setKeypoolRole === "unit") &&
                                this.props.globalKey === true ? (
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="12">
                                            <label
                                                htmlFor="defaultFormLoginEmailEx"
                                                className="black-text"
                                            >
                                                {this.state.setKeypoolRole === "unit" ? "Venue for Unit Keypool" : "Venue for Venue Keypool"}
                                            </label>
                                            {this.props.attributeForm}
                                            <div className="invalid-feedback">
                                                Please select a venue.
                                            </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                                    </MDBRow>
                                ) : (
                                    ""
                                )}
                                {this.state.setKeypoolRole === "unit" && (this.props.globalKey !== true || this.state.venueSelectedForKeypool) ? (
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="12">
                                            <label
                                                htmlFor="selectUnit"
                                                className="black-text"
                                            >
                                                Select Unit
                                            </label>
                                            <SelectSearch
                                                id="selectUnit"
                                                search={true}
                                                filterOptions={fuzzySearch}
                                                options={unitOptions}
                                                placeholder="Select a unit..."
                                                onChange={this.handleSelectUnit}
                                                value={this.state.selectedUnit}
                                            />
                                            <div className="invalid-feedback">
                                                Please select a unit.
                                            </div>
                                        </MDBCol>
                                        <MDBCol col="6"></MDBCol>
                                    </MDBRow>
                                ) : (
                                    ""
                                )}
                                {this.state.setKeypoolRole === "unit" && this.state.selectedUnit && (
                                    <MDBRow className="mt-3">
                                        <MDBCol sm="12">
                                            <div style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: "4px", padding: "12px" }}>
                                                <p className="mb-1"><strong>Current keypools assigned to this unit:</strong></p>
                                                {this.state.currentUnitSSIDs.length > 0 ? (
                                                    <ul className="mb-2 pl-4">
                                                        {this.state.currentUnitSSIDs.map((ssid, i) => (
                                                            <li key={i} style={{ color: "#495057" }}>{ssid}</li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <p className="text-muted mb-2"><em>No keypools currently assigned.</em></p>
                                                )}
                                                <p className="mb-2" style={{ color: atUnitSSIDLimit ? "#dc3545" : "#6c757d" }}>
                                                    <MDBIcon icon="info-circle" className="mr-2" />
                                                    A maximum of {MAX_UNIT_SSIDS} Unit Level SSIDs are allowed per unit ({currentUnitSSIDCount}/{MAX_UNIT_SSIDS} used).
                                                    {atUnitSSIDLimit && (
                                                        <span> This unit has reached the limit — remove an SSID before adding a new one.</span>
                                                    )}
                                                </p>
                                                {this.state.ssid && (
                                                    <>
                                                        <p className="mb-1"><strong>After adding, this unit will have:</strong></p>
                                                        <ul className="mb-0 pl-4">
                                                            {this.state.currentUnitSSIDs.map((ssid, i) => (
                                                                <li key={i} style={{ color: "#495057" }}>{ssid}</li>
                                                            ))}
                                                            {!this.state.currentUnitSSIDs.includes(this.state.ssid) && (
                                                                <li style={{ color: "#28a745", fontWeight: "bold" }}>{this.state.ssid} <span style={{ fontSize: "11px" }}>(new)</span></li>
                                                            )}
                                                        </ul>
                                                        {this.state.currentUnitSSIDs.includes(this.state.ssid) && (
                                                            <p className="text-warning mb-0 mt-1"><small>⚠ This SSID is already assigned to this unit.</small></p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                )}
                            </>
                        ) : (
                            /* ASSIGN EXISTING KEYPOOL FORM */
                            <>
                                <MDBRow>
                                    <MDBCol sm="12" lg="12">
                                        <label
                                            htmlFor="selectExistingKeypool"
                                            className="black-text"
                                        >
                                            Select Existing Keypool
                                        </label>
                                        <SelectSearch
                                            id="selectExistingKeypool"
                                            search={true}
                                            filterOptions={fuzzySearch}
                                            options={filteredKeypools}
                                            placeholder="Search keypools..."
                                            onChange={this.handleSelectExistingKeypool}
                                            value={this.state.selectedExistingKeypool}
                                        />
                                        <div className="invalid-feedback">
                                            Please select a keypool.
                                        </div>
                                        <small className="form-text text-muted">
                                            {filteredKeypools.length} keypool(s) available. 
                                            Use the search to filter (e.g., "R1" for R1 keypools).
                                        </small>
                                    </MDBCol>
                                </MDBRow>
                            </>
                        )}
                        <div className="text-right submitButton">
                            <MDBBtn 
                                color="danger" 
                                type="submit"
                                disabled={
                                    this.state.action === "create" 
                                        ? !this.state.ssid || 
                                          (!this.props.localOnly && !this.state.setKeypoolRole) ||
                                          ((this.state.setKeypoolRole === "local" || this.state.setKeypoolRole === "unit") && this.props.globalKey === true && !this.state.venueSelectedForKeypool) ||
                                          (this.state.setKeypoolRole === "unit" && !this.state.selectedUnit) ||
                                          atUnitSSIDLimit
                                        : !this.state.selectedExistingKeypool
                                }
                            >
                                {this.props.add_keypool === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    this.state.action === "create" ? "Add Keypool" : "Assign Keypool"
                                )}
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}

export default withTranslation()(AddKeypool);
